<template>
<transition name="modal">
	<div class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container teamMemberInfoContainer">
				<div class="modal-window-tab-mark">
				</div>
				<div class="modal-close-button" @click=";$emit('close')"><img src="images/x.png" class="fillImg" /></div>
				<div class="modal-wndow-content teamMemberInfo-modal-window-content">
					<div class="teamMemberInfoImg">
						<img class="fillImg" v-if="picture!=''" :src="picture"/>
					</div>
					<div class="teamMemberMoreInfoText">
						<h3><b>{{memberName}}</b></h3>
						<div class="teamMemberMoreInfoTextField" v-html="info"></div>
					</div>
					<div class="teamMemberMoreInfoSong">
						<div id="audioPlayerPath" class="audioPlayerPath" v-on:click="seekPlayer">
						<div class="audioPlayerPathCompletion" :style="'width:'+songCompletion+'%'"></div>
						</div>
						<div class="audioPlayerPlay" v-on:click="playSong()"><img class="fillImg" src="images/play.png"/></div>
						<audio id="audioPlayer" controls style="display:none">
							<source :src="song" type="audio/mpeg">
							Your browser does not support the audio element.
						</audio>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</transition>
</template>

<script>
import axios from 'axios'
var APIbase = "https://yard-bands.herokuapp.com"
export default {
	components: {},
	props: ['memberName','title','info','picture','song'],
	created() {
		
		this.loadSong()
	},
	destroyed() {
		
		this.stopSong()
	},
	data() {
		return {
			audioPlayer: null,
			songCompletion:0
		}
	},
	methods: {
		loadSong() {
			this.audioPlayer = new Audio(this.song)
			this.songCompletion = 0
			this.audioPlayer.addEventListener('timeupdate',this.updateCompletion);
		},
		updateCompletion() {
			this.songCompletion = parseInt(this.audioPlayer.currentTime, 10)*100 / parseInt(this.audioPlayer.duration, 10)	
			this.$forceUpdate();			
		},
		playSong() {
			if (this.audioPlayer) {
			
				var isPlaying = this.audioPlayer.currentTime > 0 && !this.audioPlayer.paused && !this.audioPlayer.ended && this.audioPlayer.readyState > 2;
				if (!isPlaying) {
					this.audioPlayer.play();
				}
				else {
					this.audioPlayer.pause();
				}
			}
		},
		stopSong() {
			this.audioPlayer.pause();
			this.audioPlayer.removeEventListener('timeupdate',this.updateCompletion);
			this.audioPlayer = null;
		},
		seekPlayer: function(event) {
			this.audioPlayer.currentTime = this.audioPlayer.duration * event.offsetX / document.getElementById("audioPlayerPath").offsetWidth
		}

	}
}
</script>



// WEBPACK FOOTER //
// TeamMemberInfo.vue?b3a59166